module.exports = __webpack_public_path__ + "img/faktury.d05ae92d.svg";